// extracted by mini-css-extract-plugin
export default {"dateInfo":"style_dateInfo__Dit-Q","contentWrapper":"style_contentWrapper__BDNZ-"};